import React, { useContext, useState, useEffect, useRef } from "react";
import { ContextProvider } from "../../Context";
import "../../../App.css";
import styles from "../../../Components/Dashboard/DashboardComponents/TransferComponent/transfer.module.css";
import Arrowright from "../../EducationPins/imagesEducation/educationArrowRight.svg";
import { Modal } from "../../Screens/Modal/Modal";
import messageIcon from "../ProfileImages/message-question.svg";
import bvnVerifiedSuccess from "../ProfileImages/user-tick.svg";
import PopUpGreen from "../ProfileImages/PopUpGreen.svg";
import PopUpGreenTab from "../ProfileImages/PopUpGreenTab.svg";
import PopUpGreenDeskTop from "../ProfileImages/PopUpGreenDeskTop.svg";
import Success from "../ProfileImages/success.gif";
import BvnQueryImage from "../ProfileImages/Bvnqueryimage.svg";
import BvnMessageImage from "../ProfileImages/BvnMessageImage.svg";
import ArrowDown from "../ProfileImages/arrow-down.svg";
import axios from "axios";
import PendingImage from "../ProfileImages/Pending.svg";
import NotVerifiedImage from "../ProfileImages/NotVerifiedIcon.svg";
import { GetLocalStorage } from "../../LocalStorage/LocalStorage";
import { Loader } from "../../Loader/Loader";
import countryImage from "../../EducationPins/imagesEducation/Nigeriaflag.svg";
import { BASE_URL } from "../../../config";
export default function BvnVerification() {
  const dateInputRef = useRef(null);
  const { bvnVerificationOpen, networkIssue, setNetworkIssue, setVerificationResponse,
     setSessionModal } = useContext(ContextProvider)
  const { verificationOpen } = useContext(ContextProvider);
  const { bvnVerifyImage, setBvnVerifyImage } = useContext(ContextProvider);
  const { bvnStatus, setBvnStatus } = useContext(ContextProvider);
  const [bvnDateOfBirth, setBvnDateOfBirth] = useState("");
  const { bvnNumber, setBvnNumber } = useContext(ContextProvider);
  const [bvnQuery, setBvnQuery] = useState(false);
  const [bvnPopVerified, setBvnPopVerified] = useState(false);
  const [bvnPhoneMessage, setBvnPhoneMessage] = useState(false);
  const [errorVerify, setErrorVerify] = useState("");
  const { setBvnButtonState } = useContext(ContextProvider);
  const { toggleSideBar, customerDetail } = useContext(ContextProvider);
  const { idAddress, setIdAddress } = useContext(ContextProvider);
  const { dropDownGender, setDropDownGender, setAlertCustom } = useContext(ContextProvider);
  const { isDarkMode, 
    verificationResponse,
     verificationReason, bvnPhone, setBvnPhone } =
    useContext(ContextProvider);
  const [loading, setLoading] = useState(false);
  const [genderResult, setGenderResult] = useState("");
  const [bvnNumberError, setBvnNumberError] = useState(false);
  const [phoneNumberMismatch, setPhoneNumberMismatch] = useState(false)
  // const genderInfo = ["Male", "Female", "Others.."];
  const chooseGender = () => {
    setDropDownGender(!dropDownGender);
  };

  //  CUSTOM VALIDITY FORHOUSE ADDRESS
  const validAddress = (e) => {
    const addAddress = e.target.value;
    e.target.setCustomValidity(
      addAddress ? "" : "Your Address must be entered"
    );
  };

  const { full_name} = customerDetail;
  const Data = GetLocalStorage()


  const BvnFunctionState = async (
    url,
    data,
    buttonStateSuccess,
    PendingImageFxn,
    PendingText,
    verifyBvnImage,
    statusBvn,
    verifyPopBvn
  ) => {
    if (!navigator.onLine) {
   setNetworkIssue(true);
   setErrorVerify("A Network connection error")
  // setErrorVerify("A Network connection error")
    } 
   
     if(bvnNumber?.length < 11) setBvnNumberError("Bvn Number must be 11 digits")
      if(bvnPhone?.length < 11) setPhoneNumberMismatch("Your Phone Number must be 11 digits")
    if ( navigator.onLine 
      && bvnNumber?.length === 11
      && idAddress
      && genderResult
      && bvnPhone?.length === 11
    ) {
      url = `${BASE_URL}/verify`;
      buttonStateSuccess = "Verified";
      PendingImageFxn = () => setBvnVerifyImage(PendingImage);
      PendingText = () => setBvnStatus("Pending");
      verifyBvnImage = () => setBvnVerifyImage(bvnVerifiedSuccess);
      statusBvn = () => setBvnStatus("Verified");
      verifyPopBvn = () => setBvnPopVerified(true);
      data = {
        bvn: bvnNumber.toString(),
        dob: bvnDateOfBirth,
        phone : bvnPhone,
        address: idAddress,
        gender: genderResult,
      };

      checkBvnform(
        url,
        data,
        buttonStateSuccess,
        PendingImageFxn,
        PendingText,
        verifyBvnImage,
        statusBvn,
        verifyPopBvn
      );
    }else {
      if( !bvnNumber
      || !idAddress
      || !genderResult
      || !bvnPhone)
      setErrorVerify("Fill all your details to proceed");
      //  setBvnNumberError("");
      //        setPhoneNumberMismatch("");
    }
  };

  //The main function to verify id Verification and create virtual account
  const checkBvnform = async(
    url,
    data,
    buttonStateSuccess,
    PendingImageFxn,
    PendingText,
    verifyBvnImage,
    statusBvn,
    verifyPopBvn
  ) => {
    //A chance to reset the errors of the past and redemption point,
    //before we try the necessary request
     setBvnNumberError("");
             setPhoneNumberMismatch("")
    if(bvnNumber?.length < 11) setBvnNumberError("BvnNumber must be 11 digits")
    if (bvnDateOfBirth  
   && bvnNumber?.length === 11  
     && genderResult  
      && idAddress 
       && Data?.UserFullName?.length > 1) {
      setLoading(true);
      setBvnNumberError("");
       setPhoneNumberMismatch("")
      try {
          setErrorVerify("");
          PendingImageFxn();
          PendingText();
        
        const response = await axios.post(url, data, {
          headers: {
            "Content-Type": "application/json",
           }, withCredentials : true
        });
        if (response.status === 201 || response.status ===  200) {
          setBvnNumber(response?.data?.data?.bvn);
          setBvnPhone(response?.data?.data?.phone);
          setVerificationResponse(response)
           verifyBvnImage();
          statusBvn();
          verifyPopBvn();
          setBvnButtonState(buttonStateSuccess);
          localStorage.setItem("Zxfer", "true");// Bvn Verification
            localStorage.setItem("Qhfde", "true"); // Id Verification
        }
      } catch (error) {
        if (error && error.response === undefined) {
             if(!networkIssue)  setNetworkIssue(true);
             setErrorVerify("A Network connection error");
             setBvnNumberError("");
             setPhoneNumberMismatch("")
        } else if (error.response.status ===  400) {
           if(error?.response?.data?.data?.data === "BVN name mismatch"){
                 setBvnNumberError("BVN name mismatch. Hint: Ensure it is a valid BVN Number with a matching fullname from your profile.")
            }else  if(error?.response?.data?.data?.data === "BVN phone mismatch"){
                setPhoneNumberMismatch("Phone Number Attached to your BVN");
          }
          setBvnVerifyImage(NotVerifiedImage);
  setBvnStatus("Not Verified");
  
        } else if (error.status === 500) {
          setErrorVerify("Internal Server error");
          setBvnStatus("Not Verified");
          setBvnVerifyImage(NotVerifiedImage);
        }else if(error.response.status === 401){
            setSessionModal(true)
        }else if(error?.response?.status ===409){
       
          setAlertCustom({
           message : "Verification Blocked: This verification is associated with another account, Contact Admin ",
           type : "error",
           show : true
          })
        
        } else {
           setErrorVerify("An unexpected error has occured upon verification");
            setBvnNumberError("");
             setPhoneNumberMismatch("")
        }
      } finally {
        setLoading(false);
      
      }
    }else{
      if(!bvnNumber || !genderResult  
      || !idAddress  ||!bvnDateOfBirth
       || Data?.UserFullName?.length < 1){
       setErrorVerify("Fill all your details to proceed");
      }
    }
  };
  const ValueRef = useRef();

 
  useEffect(() => {
    ValueRef.current = Data;
     if(Data?.ConfirmBvn === "true" ){
      setErrorVerify("");
      setBvnNumberError("");
      setPhoneNumberMismatch("");
    }
    if (verificationResponse?.data?.data) {
      setBvnNumber(verificationResponse?.data?.data?.bvn);
      setBvnPhone(verificationResponse?.data?.data?.phone);
    }
    // eslint-disable-next-line
  }, [Data]);



  const genderInfo = ["Male", "Female"];

  return (
    <div>
      {bvnVerificationOpen && (
        <div
          className={` flex flex-col ${verificationOpen ? "block" : "hidden"} `}
        >
          <div className="flex lg:gap-[10px] lg:py-[50px] py-[35px]  ">
            <h2
              className={`font-medium text-[#7C7C7C] text-[11px] leading-[14px] lg:text-[20px] lg:leading-[30px] ${
                isDarkMode ? "text-white" : ""
              }`}
            >
              For Nigerian User's Only
            </h2>
            <img
              className="lg:h-[24px] lg:w-[24px] h-[14.083px] w-[14.083px] md:self-center"
              src={Arrowright}
              alt=""
            />
          </div>
          {/* VERIFICATION */}
          <div className="flex md:gap-[25px] gap-[11px] lg:mb-[50px] mb-[35px]">
            {/* ICON == NOT VERIFIED */}
            <div className={`flex gap-[5px] py-[23px]
             pr-[12px] pl-[12px] md:py-[25px] md:pr-[41px]
              md:pl-[16px]  shadow-[0px_2.34722px_5.86806px_0px_rgba(0,0,0,0.25)]
               md:shadow-[0px_4px_10px_0px_rgba(0,0,0,0.25)]
               ${isDarkMode ? "bg-[#0F0F0F] text-white" : "bg-white text-black"}`}>
              <img
                src={
                  bvnVerifyImage === NotVerifiedImage &&
                  (Data.ConfirmId === "true" || Data.ConfirmBvn === "true")
                    ? bvnVerifiedSuccess
                    : bvnVerifyImage === NotVerifiedImage &&
                     ((Data.ConfirmId === "false" &&
                      Data.ConfirmBvn === "false") || (!Data?.ConfirmId  && !Data?.Confirmid))
                    ? NotVerifiedImage
                    : bvnVerifyImage === bvnVerifiedSuccess ||
                      Data.ConfirmId === "true" ||
                      Data.ConfirmBvn === "true"
                    ? bvnVerifiedSuccess
                    : NotVerifiedImage
                }
                alt=""
                className={`h-[24px] w-[24px] md:h-[44px] md:w-[44px] lg:h-[62px] lg:w-[62px]`}
              />
              <div className="flex flex-col gap-[4.694px] md:gap-[8px] justify-center">
                <h2
                  className={`font-[500] lg:text-[12px] lg:leading-[15.6px] text-[8.042px] leading-[10.45px] ${
                    isDarkMode ? "text-white" : "text-black"
                  }`}
                >
                  Bvn Status
                </h2>
                <h2
                  className={`font-[500] lg:text-[12px] lg:leading-[15.6px] text-[8.042px] leading-[10.45px] ${
                    isDarkMode ? "text-white" : "text-black"
                  }`}
                >
                  {bvnStatus === "Not Verified" &&
                  (Data.ConfirmBvn === "true" || Data.ConfirmId === "true")
                    ? "Verified"
                    : bvnStatus === "Not Verified" &&
                      (Data.ConfirmBvn === "false" ||
                        Data.ConfirmId === "false")
                    ? "Not Verified"
                    : bvnStatus === "Verified" ||
                      Data.ConfirmBvn === "true" ||
                      Data.ConfirmId === "true"
                    ? "Verified"
                    : "Not Verified"}
                </h2>
              </div>
            </div>
            {/*  */}
            <div className="flex md:gap-[14px] gap-[11px] items-center">
              <h2
                className={`font-[500] text-[#7E7E7E] text-[11px] leading-[14.4px] lg:text-[16px] lg:leading-[20.8px] ${
                  isDarkMode ? "text-white" : ""
                }`}
              >
                Why Account Verification with my Bvn?
              </h2>
              <img
                onClick={() => {
                  setBvnQuery(true);
                }}
                src={messageIcon}
                alt=""
                className="h-[14.083px] w-[14.083px] lg:h-[24px] lg:w-[24px] cursor-pointer"
              />
            </div>
          </div>
          {/* FORMS ON BVN */}
          <form
            onSubmit={(e) => {
              e.preventDefault();
            }}
            action=""
          >
            {/* Header Container */}

            <div className="flex flex-col lg:gap-[25px] gap-[35px]  w-full  ">
              <div className="flex flex-col md:flex-row lg:gap-[22px] gap-[35px] w-[100%]">
                {/* Country Bvn */}
                <div className="flex flex-col md:w-[50%] w-[100%] md:gap-[10px] gap-2.5">
                  <h2
                    className={`font-semibold  text-[13px] leading-[10.4px] lg:text-[16px] lg:leading-[20.8px] ${
                      isDarkMode ? "text-white" : "text-black"
                    }`}
                  >
                    Country
                  </h2>
                  <div
                   className={`mt-2  md:mt-0 rounded-[10px] 
             md:rounded-0  md:p-0 text-base
         sm:p-3  flex gap-2 py-[8.803px]
         pr-[13px] pl-[10.876px] font-[400] 
         leading-[10.4px] md:text-[11px] md:leading-[12.206px] 
    lg:text-[16px] lg:leading-[20.8px] md:pt-[8.802px] md:pb-[7.042px] 
    md:pr-[5.282px] md:pl-[5.867px] lg:pt-[15px] lg:pb-[12px] lg:pr-[9px] lg:pl-[10px]
      items-center cursor-pointer outline-0 border-[0.24px] 
      lg:border-[0.4px] w-full h-[45.927px] md:h-[35px] lg:h-[50px]
       border-[#9C9C9C] px-[11px] md:px-[6px] lg:px-[10px] text-[#7C7C7C] self-center  ${
      isDarkMode
        ? "bg-black text-white border border-white"
        : "hover:bg-[#EDEAEA]"
    }`} 
                  >
                    <img
                      className=" md:h-[20.27px]  h-[14.27px]
                   "
                      src={countryImage}
                      alt="Country flag"
                    />
                    <p
                      className={`text-base 
                   lg:text-[16px] lg:leading-[20.8px] ${
                     isDarkMode ? " text-white" : "text-[#7E7E7E]"
                   }`}
                    >
                      Nigeria
                    </p>
                  </div>
                </div>
                {/* Full Name */}

                <div className="flex flex-col md:w-[50%] w-[100%] md:gap-[13px] gap-2.5 ">
                  <h2
                    className={`font-[600] text-[13px] leading-[10.4px] lg:text-[16px] lg:leading-[20.8px]
                    ${
                                     isDarkMode ? "text-white" : "text-black"
                                   }`}
                  >
                    Full Name
                  </h2>
                  <div
                   className={`mt-2  md:mt-0 rounded-[10px] 
             md:rounded-0  md:p-0 text-base
         sm:p-3  flex justify-between py-[8.803px]
         pr-[13px] pl-[10.876px] font-[400] 
         leading-[10.4px] md:text-[11px] md:leading-[12.206px] 
    lg:text-[16px] lg:leading-[20.8px] md:pt-[8.802px] md:pb-[7.042px] 
    md:pr-[5.282px] md:pl-[5.867px] lg:pt-[15px] lg:pb-[12px] lg:pr-[9px] lg:pl-[10px]  items-center cursor-pointer outline-0 border-[0.24px] lg:border-[0.4px] w-full h-[45.927px] md:h-[35px] lg:h-[50px] border-[#9C9C9C] px-[11px] md:px-[6px] lg:px-[10px] text-[#7C7C7C] self-center  ${
      isDarkMode
        ? "bg-black text-white border border-white"
        : "hover:bg-[#EDEAEA]"
    }`} 
                  >
                    {full_name ? full_name : Data?.UserFullName}
                  </div>
                </div>
              </div>

              {/* Gender / Date of birth */}
              <div className="flex flex-col md:flex-row lg:gap-[22px] gap-[35px] w-[100%]">
                <div className="flex flex-col relative md:w-[50%] w-[100%] md:gap-[10px] gap-2.5">
                  <h2
                    className={`font-[600]  text-[13px] leading-[10.4px] lg:text-[16px] lg:leading-[20.8px] ${
                      isDarkMode ? "text-white" : ""
                    }`}
                  >
                    Gender
                  </h2>
                  <div
                    onClick={() => {
                      if (
                        (Data.ConfirmId === "false" &&
                          Data.ConfirmBvn === "false") ||
                        (!Data.ConfirmId && !Data.ConfirmBvn)
                      ) {
                        chooseGender();
                      } else {
                        return null;
                      }
                    }}
                  className={`mt-2  md:mt-0 rounded-[10px] 
             md:rounded-0  md:p-0 text-base
         sm:p-3  flex justify-between py-[8.803px]
         pr-[13px] pl-[10.876px] font-[400] 
         leading-[10.4px] md:text-[11px] md:leading-[12.206px] 
    lg:text-[16px] lg:leading-[20.8px] md:pt-[8.802px] md:pb-[7.042px] 
    md:pr-[5.282px] md:pl-[5.867px] lg:pt-[15px] lg:pb-[12px] lg:pr-[9px] lg:pl-[10px]  items-center cursor-pointer outline-0 border-[0.24px] lg:border-[0.4px] w-full h-[45.927px] md:h-[35px] lg:h-[50px] border-[#9C9C9C] px-[11px] md:px-[6px] lg:px-[10px] text-[#7C7C7C] self-center  ${
      isDarkMode
        ? "bg-black text-white border border-white"
        : "hover:bg-[#EDEAEA]"
    }`} 
                  >
                    <h2
                      className={`text-base leading-[18px] lg:text-[16px] lg:leading-[20.8px]
                         ${
                                     isDarkMode ? "text-white" : "text-[#7C7C7C]"
                                   }`}
                    >
                      {((Data?.ConfirmId === "false" || Data?.ConfirmBvn === "false") || (!Data?.ConfirmId && !Data?.ConfirmBvn)) 
                       && verificationResponse?.data?.data?.gender === undefined ? genderResult : 
                       verificationResponse?.data?.data?.gender === undefined && (Data?.ConfirmId === "true" || Data?.ConfirmBvn === "true") ? "NO GENDER INFO AVAILABLE" : verificationResponse?.data?.data?.gender}
                    </h2>
                    <img
                      src={ArrowDown}
                      alt=""
                      className="genderDrop lg:w-[24px] lg:h-[24px] w-[14.083px] h-[14.083px]"
                    />
                  </div>
                  {dropDownGender && (
                    <div
                        className={`absolute lg:top-[90px] md:top-[60px] top-[70px] 
          z-[5] flex flex-col w-[100%]
            ${
                    isDarkMode
                      ? "bg-black border-white rounded-[7px] text-white"
                      : "text-[#7C7C7C] bg-white rounded-br-[7px] rounded-bl-[7px] lg:rounded-br-[14px] lg:rounded-bl-[14px]"
                  }
                  ${
                    toggleSideBar
                      ? "lg:w-[31.5%] lg:top-[100.5%]"
                      : "lg:w-[38.5%] lg:top-[105.3%]"
                  }  shadow-xl border w-full lg:w-full  flex flex-col divide-y absolute top-20`}>
                      {genderInfo.map((info) => {
                        return (
                          <h2
                            onClick={() => {
                              setGenderResult(info);
                              setDropDownGender(false);
                              document
                                .querySelector(".genderDrop")
                                .classList.remove("DropIt");
                            }}
                            className = {`py-[18px] md:py-[14px]  font-normal px-2 flex
                         items-center gap-[5px] text-[12px] md:text-[14px] 
                         lg:text-[16px] shadow-[0px_3.30667px_8.26667px_0px_rgba(0,0,0,0.25)]
                          transition-all duration-300 hover:bg-slate-50 ${
                              isDarkMode
                                ? "bg-black text-white border-b border-white hover:bg-slate-800"
                                : "bg-white"
                            }`}
                          >
                            {info}
                          </h2>
                        );
                      })}
                    </div>
                  )}
                </div>
                {/* Date of birth */}
                <div className="flex flex-col md:w-[50%] w-[100%] md:gap-[10px] gap-2.5">
                  <h2
                    className={`font-[600]  text-[13px] leading-[10.4px] lg:text-[16px] lg:leading-[20.8px] ${
                      isDarkMode ? "text-white" : "text-black"
                    }`}
                  >
                    D.O.B
                  </h2>
                  <div
                    className={`w-[100%] ${
                                     isDarkMode ? "text-white" : "text-black"
                                   }`}
                    onClick={() => {
                      const input = dateInputRef.current;
                      if (input) {
                        input.showPicker ? input.showPicker() : input.click();
                      }
                    }}
                  >
                    <input
                      value={((Data?.ConfirmId === "false" || Data?.ConfirmBvn === "false") || (!Data?.ConfirmId && !Data?.ConfirmBvn)) 
                       && verificationResponse?.data?.data?.dob === undefined ? bvnDateOfBirth : 
                       verificationResponse?.data?.data?.dob === undefined && (Data?.ConfirmId === "true" || Data?.ConfirmBvn === "true") ? "NO DATE OF BIRTH" : verificationResponse?.data?.data?.dob}
                      ref={dateInputRef}
                      onChange={(e) => {
                         setBvnDateOfBirth(e.target.value);
                      }}
                    className={`mt-2  md:mt-0 rounded-[10px] 
             md:rounded-0  md:p-0 text-base
         sm:p-3  flex justify-between py-[8.803px]
         pr-[13px] pl-[10.876px] font-[400] 
         leading-[10.4px] md:text-[11px] md:leading-[12.206px] 
    lg:text-[16px] lg:leading-[20.8px] md:pt-[8.802px] md:pb-[7.042px] 
    md:pr-[5.282px] md:pl-[5.867px] lg:pt-[15px] lg:pb-[12px] lg:pr-[9px] lg:pl-[10px]  items-center cursor-pointer outline-0 border-[0.24px] lg:border-[0.4px] w-full h-[45.927px] md:h-[35px] lg:h-[50px] border-[#9C9C9C] px-[11px] md:px-[6px] lg:px-[10px] text-[#7C7C7C] self-center  ${
      isDarkMode
        ? "bg-black  border border-white text-white"
        : "hover:bg-[#EDEAEA] text-[#7C7C7C]"
    }`} 
                      type="date"
                      id="dob"
                      name="dob"
                      readOnly={
                        Data.ConfirmId === "true" || Data.ConfirmBvn === "true"
                      }
                      disabled={
                        Data.ConfirmId === "true" || Data.ConfirmBvn === "true"
                      }
                    />
                  </div>
                </div>
              </div>

              {/*HOUSE ADDRESS / PHONE NUMBER */}
              <div className="flex flex-col md:flex-row lg:gap-[22px] gap-[35px] w-[100%]">
                {/* HOUSE ADDRESS */}
                <div className="flex flex-col md:w-[50%] w-[100%] md:gap-[10px] gap-2.5">
                  <h2
                    className={`font-[600] text-[#7E7E7E] text-[13px] leading-[10.4px] 
                      lg:text-[16px] lg:leading-[20.8px] ${
                                     isDarkMode ? "text-white" : "text-black"
                                   }`}
                  >
                    House Address
                  </h2>
                  <input
                    value={((Data?.ConfirmId === "false" || Data?.ConfirmBvn === "false") || (!Data?.ConfirmId && !Data?.ConfirmBvn)) 
                       && verificationResponse?.data?.data?.address === undefined ? idAddress : 
                       verificationResponse?.data?.data?.address === undefined && (Data?.ConfirmId === "true" || Data?.ConfirmBvn === "true") ? "NO ADDRESS" : verificationResponse?.data?.data?.address}
                    onChange={(e) => {
                      setIdAddress(e.target.value);
                    }}
                    className={`mt-2  md:mt-0 rounded-[10px] 
             md:rounded-0  md:p-0 text-base
         sm:p-3  flex justify-between py-[8.803px]
         pr-[13px] pl-[10.876px] font-[400] 
         leading-[10.4px] md:text-[11px] md:leading-[12.206px] 
    lg:text-[16px] lg:leading-[20.8px] md:pt-[8.802px] md:pb-[7.042px] 
    md:pr-[5.282px] md:pl-[5.867px] lg:pt-[15px] lg:pb-[12px] lg:pr-[9px] lg:pl-[10px]  items-center cursor-pointer outline-0 border-[0.24px] lg:border-[0.4px] w-full h-[45.927px] md:h-[35px] lg:h-[50px] border-[#9C9C9C] px-[11px] md:px-[6px] lg:px-[10px] text-[#7C7C7C] self-center  ${
      isDarkMode
        ? "bg-black text-white border border-white"
        : "hover:bg-[#EDEAEA]"
    }`} 
                    placeholder=""
                    readOnly={
                      Data.ConfirmId === "true" || Data.ConfirmBvn === "true"
                    }
                    type="text"
                    onInvalid={validAddress}
                    required
                  />
                </div>

                {/* PHONE NUMBER */}
                <div className="flex flex-col md:w-[50%] w-[100%] md:gap-[10px] gap-2.5">
                  {/* header */}
                  <div className="flex md:gap-x-[10px] gap-x-[5px]">
                    <h2
                      className={`font-[600] text-[#7E7E7E] text-[13px] leading-[10.4px] 
                        lg:text-[16px] lg:leading-[20.8px]'
                        ${
                                     isDarkMode ? "text-white" : "text-black"
                                   }`}
                    >
                      Phone Number
                    </h2>
                    <img
                      onClick={() => {
                        setBvnPhoneMessage(true);
                      }}
                      src={messageIcon}
                      alt=""
                      className="h-[14.083px] w-[14.083px] lg:h-[24px] lg:w-[24px] cursor-pointer"
                    />
                    
                  </div>
                  {/* Input */}
                  <input
                    readOnly = {Data?.ConfirmId === "true" 
                      || Data?.ConfirmBvn === "true"}
                    value={
                      ((verificationResponse?.data?.data?.phone !== undefined && Data.ConfirmBvn === "true")|| (verificationResponse?.data?.data?.phone && bvnPhone?.length > 1))
                        ? `${bvnPhone?.slice(0, 4)}*******`
                        : verificationResponse?.data?.data?.phone === undefined && (Data?.ConfirmId === "true" || Data?.ConfirmBvn === "true") ? "NO Phone Number"
                         : verificationResponse?.data?.data?.phone === undefined &&
                          ( Data?.ConfirmBvn === "false" || !Data?.ConfirmBvn) ? bvnPhone : ""
                    }
                    onInput={(e) => {
                      const numericValue = e.target.value.replace(/\D/g, "");
                      e.target.value = numericValue;
                    }}
                    onChange={(e) => {
                      setBvnPhone(e.target.value);
                    }}
                    type="tel"   
                    name="phone"
                    id="phone"
                    maxLength={11}
                    inputMode="tel"
                    required
                   className={`mt-2  md:mt-0 rounded-[10px] 
             md:rounded-0  md:p-0 text-base
         sm:p-3  flex justify-between py-[8.803px]
         pr-[13px] pl-[10.876px] font-[400] 
         leading-[10.4px] md:text-[11px] md:leading-[12.206px] 
    lg:text-[16px] lg:leading-[20.8px] md:pt-[8.802px] md:pb-[7.042px] 
    md:pr-[5.282px] md:pl-[5.867px] lg:pt-[15px] lg:pb-[12px] lg:pr-[9px] lg:pl-[10px]  items-center cursor-pointer outline-0 border-[0.24px] lg:border-[0.4px] w-full h-[45.927px] md:h-[35px] lg:h-[50px] border-[#9C9C9C] px-[11px] md:px-[6px] lg:px-[10px] text-[#7C7C7C] self-center  ${
      isDarkMode
        ? "bg-black text-white border border-white"
        : "hover:bg-[#EDEAEA]"
    }`} 
                  />
                     {phoneNumberMismatch?.length > 1  && (
                  <h2
                    className={`font-[500] lg:text-[14px] lg:leading-[18px] 
                      md:text-[14px] md:leading-[18px] text-[12px] leading-[16px]
                       text-red-600`}
                  >
                    {phoneNumberMismatch}
                  </h2>
                )}
                </div>
              </div>
              <div className="flex flex-col md:flex-row lg:gap-[22px] gap-[20px] w-[100%]">
                {/* BVN NUMBER */}
                <div className="flex flex-col md:w-[50%] w-[100%] md:gap-[10px] gap-2.5">
                  <h2
                    className={`font-[600] text-[#7E7E7E] text-[13px] leading-[10.4px]
                       lg:text-[16px] lg:leading-[20.8px]  ${
                                     isDarkMode ? "text-white" : "text-black"
                                   }`}
                  >
                    BVN Number
                  </h2>
                  <input
                    readOnly={
                      Data.ConfirmBvn === "true" || Data.ConfirmId === "true"
                    }
                    onInput={(e) => {
                      const numbersOnly = e.target.value.replace(/\D/g, "");
                      e.target.value = numbersOnly;
                    }}
                    value={
                      ((verificationResponse?.data?.data?.bvn !== undefined && Data.ConfirmBvn === "true") || (verificationResponse?.data?.data?.bvn && bvnNumber?.length > 1))
                        ? `${bvnNumber?.slice(0, 4)}*******`
                        : verificationResponse?.data?.data?.bvn === undefined && (Data?.ConfirmId === "true" || Data?.ConfirmBvn === "true") ? "NO BVN"
                         :  (verificationResponse?.data?.data?.bvn === undefined &&( Data?.ConfirmBvn === "false" || !Data?.ConfirmBvn)) ? bvnNumber : ""
                    }
                    onChange={(e) => {
                      setBvnNumber(e.target.value);
                    }}
                  className={`mt-2  md:mt-0 rounded-[10px] 
             md:rounded-0  md:p-0 text-base
         sm:p-3  flex justify-between py-[8.803px]
         pr-[13px] pl-[10.876px] font-[400] 
         leading-[10.4px] md:text-[11px] md:leading-[12.206px] 
    lg:text-[16px] lg:leading-[20.8px] md:pt-[8.802px] md:pb-[7.042px] 
    md:pr-[5.282px] md:pl-[5.867px] lg:pt-[15px] lg:pb-[12px] lg:pr-[9px] lg:pl-[10px]  items-center cursor-pointer outline-0 border-[0.24px] lg:border-[0.4px] w-full h-[45.927px] md:h-[35px] lg:h-[50px] border-[#9C9C9C] px-[11px] md:px-[6px] lg:px-[10px] text-[#7C7C7C] self-center  ${
      isDarkMode
        ? "bg-black text-white border border-white"
        : "hover:bg-[#EDEAEA]"
    }`} 
                    type="text"
                    inputMode="numeric"
                    maxLength={11}
                    required
                  />
                  {(verificationReason?.length > 1 && bvnNumber?.length < 1 && bvnNumberError?.length < 1) && (
                    <p
                      className="text-[12px] font-[600] leading-[12px] text-red-500
  capitalize md:text-[9.17px] md:leading-[11.92px] lg:text-[16px] lg:leading-[24px]"
                    >
                      {verificationReason}
                    </p>
                  )}
                  {bvnNumberError?.length > 1 && verificationReason?.length < 1 &&  (
                  <h2
                    className={`font-[500] lg:text-[14px] lg:leading-[18px] 
                      md:text-[14px] md:leading-[18px] text-[12px] leading-[16px]
                       text-red-600`}
                  >
                  {bvnNumberError}
                  </h2>
                )}
                </div>
              </div>

              <div className="flex flex-col md:gap-[15px] gap-[10px] justify-start">
                <button
                  disabled={
                    Data.ConfirmBvn === "true"
                     || Data.ConfirmId === "true"
                  }
                  onClick={() => {
                    BvnFunctionState();
                  }}
                  className={`lg:py-[13px] md:py-[7.868px] py-[16.531px] rounded-[4.241px] w-[100%] md:w-[150px] lg:w-[163px] lg:rounded-[12px] bg-[#04177F]
         font-[600] text-[12px] leading-[18px] lg:text-[16px] text-center text-white lg:leading-[24px ${
           (Data.ConfirmBvn === "true" || Data?.ConfirmId === "true") ? "bg-slate-400" : "bg-[#04177F]"
         }`}
                >
                  {
                  (Data.ConfirmBvn === "true" || Data.ConfirmId === "true")
                    ? "Verified"
                    : "Verify"}
                </button>
                {errorVerify?.length > 1 && (
                  <h2
                    className={`font-[500] lg:text-[14px] lg:leading-[18px] 
                      md:text-[14px] md:leading-[18px] text-[12px] leading-[16px]
                       text-red-600`}
                  >
                    {errorVerify}
                  </h2>
                )}
              </div>
            </div>
          </form>
          {/* ========== MODALS ========= */}
          {bvnQuery && (
            <Modal>
              <div className=" h-[100%] flex flex-col w-[100%]
               items-center justify-center">
                <div
                  className={`bvnQuery flex flex-col shadow-[0px_0px_8.3274px_0px_rgba(0 0 0,0.25)]
                     rounded-[8px] shadow-[0px_0px_8.3274px_0px_rgba(0,0,0,0.25)] md:rounded-[11.736px]  
                     lg:rounded-[20px] md:w-[55%]
            md:shadow-[0px_0px_11.73611px_0px_rgba(0,0,0,0.25)]
             lg:shadow-[0px_0px_20px_0px_rgba(0,0,0,0.25)] justify-center 
              items-center px-[18px] md:px-[30px] md:h-[550px] h-[430px]
              gap-[10px] md:gap-[40px] lg:gap-[50px] lg:justify-normal md:mx-[0px]
               mx-[19px]  lg:pt-[30px]  md:pt-[270px] pt-[270px] ${
              isDarkMode ? "bg-black border border-white" : "bg-white"
            }`}
                >
                  <div className="flex flex-col items-center ">
                    <div className="flex flex-col  md:gap-[20px] gap-[10px]">
                      <p className="font-[400] text-[13px] text-center leading-[16.4px] lg:text-[16px] lg:leading-[20.8px]">
                        BVN (Bank Verification Number) validates your bank
                        details for security.
                      </p>
                      <p className="font-[400] text-[13px] text-center leading-[16.4px] lg:text-[16px] lg:leading-[20.8px]">
                        This verification enhance security, prevent fraud, and
                        ensure accurate payouts. Your personal data is securely
                        encrypted.
                      </p>
                    </div>
                    <img
                      src={BvnQueryImage}
                      alt=""
                      className="lg:w-[460px] lg:h-[490.72px] md:h-[290px] md:w-[290px] w-[100%] h-[206.742px] cursor-pointer"
                    />
                  </div>
                  {/*  */}

                  <div className="flex flex-col gap-[20px] md:gap-[23.47px] lg:gap-[40px] mb-[50px]">
                    {/* Header */}
                    <h2 className="font-[700] lg:text-[16px] lg:leading-[19.2px] text-center text-[13px] leading-[16.4px] ">
                      Why do we request your BVN for account verification?
                    </h2>
                    {/* Paragraph */}
                    <div className="flex flex-col md:gap-[20px] gap-[10px] items-center">
                      <p className="font-[500] lg:text-[16px] lg:leading-[19.2px] text-left text-[13px] leading-[16.4px] ">
                        <span className="font-[700]">1. Security:</span> We take
                        your financial security seriously. Verifying your BVN
                        helps us confirm your bank details, ensuring that your
                        transactions are secure.
                      </p>
                      <p className="font-[500] lg:text-[16px] lg:leading-[19.2px] text-left text-[13px] leading-[16.4px]">
                        <span className="font-[700]">2. Accuracy: </span>To
                        provide you with the best service, we need accurate
                        information. Verifying your BVN ensures precise payouts
                        and helps prevent errors in your transactions.
                      </p>
                    </div>
                  </div>
                  <div className="flex w-[100%] md:justify-center">
                    <button
                      onClick={() => {
                        setBvnQuery(false);
                      }}
                      className="font-[600] w-[100%] bg-[#04177F] md:w-[163px] md:py-[5.868px] lg:py-[13px] text-white lg:rounded-[12px] text-[13px] leading-[16.4px] rounded-[7.042px] lg:text-[16px] lg:leading-[24px]   py-[16.531px] md:mb-[40px] mb-[20px]"
                    >
                      Okay
                    </button>
                  </div>
                </div>
              </div>
            </Modal>
          )}
          {bvnPopVerified && (
          <div className={`w-full h-full  justify-center items-center
   flex`}>
    <Modal>
              <div
               className={`w-full relative flex px-[17px] lg:px-[20px]  items-center justify-center 
             `}>
               <div className = {`flex flex-col justify-left relative items-center
             py-[20px] px-[10px] gap-[20px] w-[100%] md:w-[60%] md:h-auto lg:w-[30%]  rounded-[10px]
             lg:rounded-[20px]   ${isDarkMode  ? "bg-black border border-white rounded-[10px]" 
               : "bg-white"}`}>
                <img
                    src={PopUpGreen}
                    alt=""
                    className="md:hidden absolute z-0 right-0 top-0   rounded-tr-[10px]"
                  />
                   <img
                    src={PopUpGreenTab}
                    alt=""
                    className="absolute top-0 right-0 hidden md:block lg:hidden rounded-tr-[10px]"
                  />
                  <img
                    src={PopUpGreenDeskTop}
                    alt=""
                    className="hidden w-[200px] absolute z-0 opacity-70  top-0 right-0 lg:block rounded-tr-[20px]"
                  />
                  <h2 className={`text-[14px] text-center font-[600] leading-[18px]
               text-black lg:text-[16px] lg:leading-[22px]  ${isDarkMode   ? "text-white" : "text-black"}`}>
                Successful
           </h2>
                    
                  <img
                    src={Success}
                    alt=""
                    className="h-[100px] w-[100px]"
                  />
              
                  <p
                    className={`text-[10px] px-[20px] md:text-[16px] lg:text-[18px] 
                  font-semibold text-center mt-[4%] lg:my-[%] z-[1000] ${styles.overlayText}`}
                  >
                    Your BVN has been verified successfully.
                  </p>
               

             

                <button
                  onClick={(e) => {
                    e.preventDefault();
                    setBvnPopVerified(false);
                    setBvnDateOfBirth(bvnDateOfBirth);
                    setBvnPhone(bvnPhone);
                  }}
                  className={`my-[5%] bg-[#04177f] w-[90%] flex 
                justify-center items-center mx-auto cursor-pointer text-[10px] 
                font-extrabold h-[40px] text-white rounded-[6px] md:w-[25%] md:rounded-[8px] md:text-[16px] lg:w-[163px] lg:h-[38px] lg:my-[2%]`}
                >
                  Done
                </button>
              </div>
              </div>
            </Modal>
            </div>
          )}
          {bvnPhoneMessage && (
            <Modal>
              <div
                className={`flex flex-col lg:gap-[44px] md:gap-[25px] gap-[20px] lg:h-[465px] h-[330px] w-[100%] md:w-[45%]
          shadow-[0px_0px_8.3274px_0px_rgba(0,0,0,0.25)] rounded-[8px] px-[18px] md:px-[0px] lg:rounded-[12px] lg:shadow-[0px_0px_20px_0px_rgba(0,0,0,0.25)] mx-[19px] md:mx-[0px] md:shadow-[0px_0px_11.73611px_0px_rgba(0,0,0,0.25)] items-center justify-center ${
            isDarkMode ? "bg-black border border-white" : "bg-white"
          }`}
              >
                <h2 className="font-[600] lg:text-[16px] lg:leading-[24px]  text-[13px] text-center leading-[16.206px] ">
                  The phone number associated with your BVN for verification.
                </h2>
                <div className="flex justify-center  w-[100%]">
                  <img
                    src={BvnMessageImage}
                    alt=""
                    className="lg:w-[223px] lg:h-[223px] md:h-[130.858px] 
      md:w-[130.858px] h-[130.858px] w-[130.858px]"
                  />
                </div>
                {/* OKAY BUTTON PHONE MESSAGE */}
                <div className="flex w-[100%] md:justify-center">
                  <button
                    onClick={() => {
                      setBvnPhoneMessage(false);
                    }}
                    className="font-[600] lg:py-[13px] md:py-[5.868px] py-[16.531px]  md:w-[163px] w-[100%]
       text-white bg-[#04177F]  rounded-[4.61px]
      lg:rounded-[12px] lg:text-[16px] lg:leading-[24px]  text-[13px]  leading-[16.206px] "
                  >
                    Okay
                  </button>
                </div>
              </div>
            </Modal>
          )}
        </div>
      )}
      {loading && (
        <Modal>
          <Loader />
        </Modal>
      )}
    
    </div>
  );
}
